/**
 * 판정 기록·룰 API 공통 오류 객체 (spec D-12).
 *
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 *
 * 관리자 API 모듈은 공통 봉투 `{ error, data?, message? }`를 언랩하지 않고 반환하고
 * 훅이 `error === 0`을 판정한다. 기존 `throw new Error(message)` 관례(useDoseRules.ts)는
 * 코드와 `data`를 잃어 6120(삭제된 기록)·6122(data.label)·6124·6125 분기를 못 한다.
 * 조회 훅·CSV·(Phase 4) 뮤테이션은 `error !== 0`이면 이 오류를 던지고, 화면은
 * `instanceof DoseApiError`와 `code`로 가른다. HTTP 400·네트워크 오류는 axios 오류 그대로다.
 *
 * 형제전파 spec(재추출 뮤테이션)과 공용 — 먼저 머지되는 쪽이 만들고 나중 쪽은 import한다(D-12).
 */
export class DoseApiError extends Error {
  code: number;
  data: unknown;

  constructor({ code, message, data }: { code: number; message?: string; data?: unknown }) {
    super(message || `요청이 실패했습니다 (${code})`);
    this.name = "DoseApiError";
    this.code = code;
    this.data = data ?? null;
    // 트랜스파일 대상(ES5 등)과 무관하게 instanceof를 보장한다.
    Object.setPrototypeOf(this, DoseApiError.prototype);
  }
}
